var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-mainHeader__gMenuItem"},[_c('div',{staticClass:"text-decoration-none",class:{ active: _vm.active }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }